import * as React from "react";
import type { SVGProps } from "react";
import PropTypes from 'prop-types';
/* istanbul ignore file */
interface Props extends SVGProps<SVGSVGElement> {
  srText?: string;
  size?: 'sm' | 'md' | 'lg' | 'scale-8' | 'scale-10' | number;
  alt?: string;
}
function IconSolidBgWhiteCheckmark({
  srText,
  size = 'md',
  className = '',
  ...props
}: Props) {
  const newClassName = `mc-icon mc-icon--${size} ${className}`;
  return <>{!!srText && <span className='mc-sr-only'>{srText}</span>}<svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" aria-hidden="true" role="img" className={newClassName} {...props}><rect width={23} height={23} x={0.5} fill="currentColor" rx={12} /><path fill="#fff" fillRule="evenodd" d="M18.288 7.686c.27.26.284.698.033.978l-6.826 7.615a.66.66 0 0 1-.488.221.66.66 0 0 1-.488-.22l-3.84-4.284a.71.71 0 0 1 .033-.979.65.65 0 0 1 .943.035l3.352 3.74 6.338-7.071a.65.65 0 0 1 .943-.035" clipRule="evenodd" /></svg></>;
}
IconSolidBgWhiteCheckmark.propTypes = ({
  srText: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string
} as PropTypes.ValidationMap<Props>);
export default IconSolidBgWhiteCheckmark;